import React from 'react';

interface Props {
  current: number;
  total: number;
}

const ProgressBar: React.FC<Props> = ({ current, total }) => {
  const percentage = Math.round((current / (total - 1)) * 100);

  return (
    <div className="totem-progress-bar">
      <div className="totem-progress-fill" style={{ width: `${percentage}%` }} />
    </div>
  );
};

export default ProgressBar;
